var map = {
	"./vessel-dark-arrow.svg": "ac81",
	"./vessel-dark-circle.svg": "5289",
	"./vessel-error-arrow.svg": "6e32",
	"./vessel-error-circle.svg": "c072",
	"./vessel-highlight-arrow.svg": "a8d6",
	"./vessel-highlight-circle.svg": "c1cb",
	"./vessel-light-arrow.svg": "8ba8",
	"./vessel-light-circle.svg": "345a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eae1";